// extracted by mini-css-extract-plugin
export default {"RegistrationTimeline":"Timelines_RegistrationTimeline__sU0xD","name":"Timelines_name__WvBMg","role":"Timelines_role__OIduS"};